<template>
  <div class="wechatLogin">
    <!-- 微信登录 修改微信登陆时注意 wxReg 与 wxLoginPage 页面  -->
    <div>
      <div
        id="login_container"
        style="
          height: 300px;
          overflow: hidden;
          text-align: center;
          padding-top: 12px;
        "
      ></div>
      <div class="submitTip">
        {{ $t("login.agreePolicy")
        }}<a style="cursor: pointer" @click="$emit('userAgree')">{{
          $t("login.servicePolicy")
        }}</a
        ><a style="cursor: pointer" @click="$emit('privacyAgree')">{{
          $t("login.userPrivacyPolicy")
        }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return { loginType: '', timeVal: '' }
  },
  created () {
    this.loginC()
  },
  methods: {
    loginC () {
      this.loginType = '3'
      clearInterval(this.timeVal)
      this.timeVal = null
      setTimeout(() => {
        const url = `${location.origin}/wxLoginPage`
        // eslint-disable-next-line no-undef
        var obj = new WxLogin({
          self_redirect: true,
          id: 'login_container',
          appid: 'wx7212a05a406ddfc3',
          scope: 'snsapi_login',
          redirect_uri: encodeURIComponent(url), // wxLoginPage
          state: 'STATE',
          href: 'https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/shopping/scene/wxLogin.css'
        })
        console.log(obj)
      }, 100)
    }
  }
}
</script>

<style lang="scss" scoped>
.wechatLogin {
  width: 100%;
  padding: 24px;
  .submitTip {
    font-family: AlibabaPuHuiTi;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #666666;
    margin-top: 8px;
    ::v-deep .el-checkbox__label {
      font-size: 12px;
      line-height: 18px;
      text-align: center;
      color: #666666;
    }
    a {
      color: #2a54d1;
    }
  }
}
</style>
